import DcLogo2 from "../resources/images/logos/dc-logo2.webp";

export const DARKCOUNTRY_COLLECTION = {
    image: DcLogo2,
    name: 'DarkCountry',
    templates: [
        'Common Land',
        'Rare Land',
        'Epic Land',
        'Legendary Land',
        'Mythical Land',
        'Common Card',
        'Rare Card',
        'Epic Card',
        'Legendary Card',
        'Mythical Card',
        'Rare Hero',
        'Epic Hero',
        'Legendary Hero',
        'Mythical Hero',
        'Rancho Pack',
        'Mayor’s Pack',
        'Governor’s Pack',
        'Bonus Pack'
    ]
};
